import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { activityLogsKeys } from './getActivityLogs';
import { fileDetailsKeys } from './getFileDetails';

import { isResponseError } from '../../../../api/config';
import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { UpdateFileEntryResponse } from '../../../../types';

const url = `${PREFIX_URL}/inbox-documents/:fileId`;

export type RecordFileDTO = {
  fileId: number;
  record: boolean;
};

export const recordFile = ({ fileId, record }: RecordFileDTO): Promise<UpdateFileEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { fileId }),
    { record },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type useRecordFileOptions = {
  fileId: number;
  config?: MutationConfig<typeof recordFile>;
};

export const useRecordFile = ({ fileId, config }: useRecordFileOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      queryClient.setQueryData([...fileDetailsKeys.detail({ fileId })], (prev: any) => {
        return {
          ...prev,
          data: data.data['inbox-document'],
        };
      });

      queryClient.invalidateQueries([...activityLogsKeys.list(fileId)]);
    },
    ...config,
    mutationFn: ({ record }) => recordFile({ fileId, record }),
  });
};
